/*
    created by cc 编辑图片
    2016-3-30
 */
'use strict';
angular.module('atlasEditImageModule', []).
controller('editImageCtrl', editImageCtrl);
editImageCtrl.$injector = ["$scope", "$stateParams", "$timeout", "$modalInstance", "uploadImg", "trsHttpService", "modalDialog"];

function editImageCtrl($scope, $stateParams, $timeout, $modalInstance, uploadImg, trsHttpService, modalDialog) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {
            uploadImg: {
                'src': uploadImg.PERPICURL
            },
            lockBtn: false,
            showAddIcon: false, //显示添加图标
            isShowRoutes: false, //是否显示路径和上一级按钮
            progress: ""
        };
        $scope.page = {
            ITEMCOUNT: "0",
            CURRPAGE: "1",
            PAGESIZE: "20",
            PAGECOUNT: "1"
        };
        $scope.data = {
            navs: [{
                name: "我的图片",
                value: "1"
            }, {
                name: "本地图片",
                value: "2"
            }],
            myPictures: [], //我的图片列表
            selectedPicture: "", //我的图片选中图片
            currFileId: "0", //当前文件夹的id
            keywords: "", //检索关键词
        };
        $scope.params = {
            "serviceid": "mlf_releaseSource", //服务名
            "methodname": "queryPersonalMaterials", //方法名
            "PersonalMaterialId": "0", // 主键，唯一性
            "status": "0", //正常
            "fileType": "2", //数据类型
            "order": "0", //0：按创建时间排序，1：显示名称排序
            "searchValue": "", //搜索内容
            "CurrPage": $scope.page.CURRPAGE,
            "PageSize": $scope.page.PAGESIZE
        };
        $scope.data.selectedNav = $scope.data.navs[0].value;
    }

    function initData() {
        requestData();
        $scope.callBack = {
            success: function(file, src, uploader) {
                if (angular.isUndefined(src.imgSrc)) {
                    modalDialog.alertType("文件" + file.name + "上传失败！", "", "error", "confirm");
                } else {
                    var uploadedSrc = {
                        'PERPICURL': src.imgSrc,
                        'APPFILE': src.imgName,
                        'APPDESC': file.name.replace(/\.\w+$/, ''),
                    };
                    if ($scope.status.progress == '100%') {
                        $modalInstance.close(uploadedSrc);
                    }
                }
            },
            error: function(file) {
                $modalInstance.dismiss();
            },
            file: function(file, uploader) {
                uploader.makeThumb(file[0], function(error, src) {
                    $timeout(function() {
                        $scope.status.uploadImg = {
                            'src': src
                        };
                    });
                });
                $scope.theFinish = function() {
                    uploader.upload();
                };
            },
            tar: function(file, percentage) {
                $timeout(function() {
                    $scope.status.progress = Math.ceil(percentage * 100) + "%";
                });
            },
            comp: function(file) {

            },
            start: function() {
                $scope.theFinish = function() {
                    uploader.upload();
                };
            }
        };
    }
    /**
     * [finish description] 完成
     * @return {[type]} [description]
     */
    $scope.finish = function() {
        $scope.status.lockBtn = true;
        if ($scope.data.selectedNav == '1') {
            addMyPictures();
        } else if ($scope.data.selectedNav == '2') {
            $scope.theFinish();
        }
    };
    /**
     * [requestData description] 请求我的图片数据
     * @return {[type]} [description]
     */
    function requestData() {
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
            $scope.data.myPictures = data.DATA;
            $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT; //页数
            $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT; //文件数量
            getFileRoutes();
        });
    }
    /**
     * [getAutoHeight description] 居中提示文字
     * @return {[type]} [description]
     */
    $scope.getAutoHeight = function() {
        $timeout(function() {
            var bodyHeight = $(".publicModal .body").height(),
                fixedAreaHeight = $(".fixedArea").height();
            var contentHeight = bodyHeight - fixedAreaHeight;
            $(".uploadContent.localUpload").height(contentHeight);
        }, 500);
    };
    /**
     * [getFileRoutes description] 获取当前文件的导航
     * @return {[type]} [description]
     */
    function getFileRoutes() {
        if ($scope.data.currFileId == "0") {
            $scope.status.isShowRoutes = false;
            return;
        } else {
            var params = {
                serviceid: "mlf_releaseSource",
                methodname: "getPersonalMaterialDaoHang",
                PersonalMaterialId: $scope.data.currFileId
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var rootRoute = [{
                    FILEDESC: "全部文件",
                    PERSONALMATERIALID: "0",
                    fileTitle: "全部文件"
                }];
                data.sort(function(x, y) {
                    return 1;
                });
                $scope.data.allRoutes = rootRoute.concat(data);
                $scope.status.isShowRoutes = true;
            });
        }
    }
    /**
     * [turnBackToPreviousRoute description] 返回上一级目录
     * @return {[type]} [description]
     */
    $scope.turnBackToPreviousRoute = function() {
        var routesLength = $scope.data.allRoutes.length;
        var route = $scope.data.allRoutes[routesLength - 2];
        turnBack(route);
    };
    $scope.turnBackToAllFile = function() {
        var route = $scope.data.allRoutes[0];
        turnBack(route);
    };
    /**
     * [turnBack description] 返回指定目录
     * @param  {[type]} route [description] 指定目录
     * @return {[type]}       [description]
     */
    function turnBack(route) {
        $scope.params.searchValue = "";
        $scope.data.keywords = "";
        $scope.params.PersonalMaterialId = route.PERSONALMATERIALID;
        $scope.data.currFileId = route.PERSONALMATERIALID;
        $scope.params.CurrPage = $scope.page.CURRPAGE = "1";
        $scope.status.copyCurrPage = 1;
        requestData();
    }
    /**
     * [search description] 搜索
     * @param  {[type]} ev [description] 键盘按键
     * @return {[type]}    [description]
     */
    $scope.search = function(ev) {
        if (angular.isDefined(ev) && ev.keyCode == 13) {
            $scope.params.searchValue = angular.copy($scope.data.keywords);
            $scope.params.CurrPage = $scope.page.CURRPAGE = "1";
            $scope.status.copyCurrPage = 1;
            requestData();
        }
    };
    /**
     * [findChildrenFile description] 查看文件夹内的子文件，或文件详情
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.findChildrenFile = function(item) {
        if (item.FILETYPE == "0") {
            $scope.params.searchValue = "";
            $scope.data.keywords = "";
            $scope.params.PersonalMaterialId = item.PERSONALMATERIALID;
            $scope.data.currFileId = item.PERSONALMATERIALID;
            $scope.params.CurrPage = $scope.page.CURRPAGE = "1";
            $scope.status.copyCurrPage = 1;
            requestData();
        }
    };
    /**
     * [changeNav description] 切换标签
     * @param  {[type]} nav [description] 标签数据
     * @return {[type]}    [description]
     */
    $scope.changeNav = function(nav) {
        $scope.data.selectedNav = nav.value;
        $scope.data.keyWords = $scope.data.keywords = '';
        if (nav.value == '2') {
            $scope.getAutoHeight();
        }
    };
    /**
     * [pageChanged description]跳转到下一页
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.params.CurrPage = $scope.page.CURRPAGE;
        $scope.status.copyCurrPage = $scope.page.CURRPAGE;
        requestData();
        $(".uploadRsource .body").animate({scrollTop:0},'fast');
    };
    /**
     * [addMyPictures description] 添加我的图片
     * @param {[type]} uploadPic [description]
     */
    function addMyPictures() {
        var uploadPic = {
            'PERPICURL': $scope.data.selectedPicture.SRCIMGURL,
            'APPFILE': $scope.data.selectedPicture.FILENAME,
            'APPDESC': $scope.data.selectedPicture.FILEDESC.replace(/\.\w+$/, ''),
        };
        $modalInstance.close(uploadPic);
    }
    /**
     * [close description] 取消
     * @return {[type]} [description]
     */
    $scope.close = function() {
        $modalInstance.dismiss();
    };
}